import { render, staticRenderFns } from "./CoozzyAddressCardIcon.vue?vue&type=template&id=d2151190&scoped=true"
import script from "./CoozzyAddressCardIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyAddressCardIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyAddressCardIcon.vue?vue&type=style&index=0&id=d2151190&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2151190",
  null
  
)

export default component.exports